/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router'
import PageTitle from '../../../../client/js/components/PageTitle'
import useQueryParams from '../../../../client/js/hooks/useQueryParams'
import MandateListCard, { MandateListQuery } from '../mandate/MandateListCard'
import { Container } from '@mantine/core'
import { getMandateCreateLink } from '../../lib/links/mandateLinks'
import Page from '../../../../client/js/components/Page'
import { useRouteLoaderData } from '../../../../client/js/components/RouteLoaderData'
import EstateBreadcrumb from './EstateBreadcrumb'

function EstateMandateListPage () {
  const intl = useIntl()
  const params = useParams<{ id: string }>()
  const estateId = parseInt(params.id, 10)
  const estate = useRouteLoaderData<Estate>()

  const [searchParams, setSearchParams] = useQueryParams()
  const searchQuery: MandateListQuery = useMemo(() => ({
    ...searchParams,
    estateId: params.id
  }), [params.id, searchParams])

  const title = intl.formatMessage({
    id: 'mandates',
    defaultMessage: 'Mandats'
  })

  return (
    <Page>
      <Container size="xl">
        <PageTitle
          hidden
          title={title}
        />

        <EstateBreadcrumb
          estate={estate}
          title={title}
        />

        <MandateListCard
          createLink={getMandateCreateLink({
            estateId,
            customerId: estate?.ownerId
          })}
          query={searchQuery}
          onQueryChange={setSearchParams}
        />
      </Container>
    </Page>
  )
}

export default EstateMandateListPage
